import type { Immutable } from "immer";
import React from "react";

import type { MediaBlock as MediaBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

/**
 * Faithful port of the legacy server-rendered ``cms/blocks/media-block.html``
 * (the tempurpedic-local MediaBlock variant; the shared libs MediaBlock is a
 * separate block).
 *
 * Legacy markup: ``<section class="media-block {visibility}">{{
 * value.wistia_embed }}</section>``. ``wistia_embed`` is an ``EmbedBlock`` whose
 * value serializes to the raw embed HTML string (which may include the Wistia
 * async <script>), so we inject it via ``dangerouslySetInnerHTML`` -- matching
 * the legacy autoescape-off embed render. No custom JS is added (the legacy
 * template had none).
 */
export const MediaBlock = (
    props: Immutable<{ value: MediaBlockValue }>,
): React.JSX.Element => {
    const v = props.value;
    return (
        <section
            className={concatClassNames([
                "media-block",
                v.responsive_visibility?.visibility ?? "",
            ])}
            dangerouslySetInnerHTML={{ __html: v.wistia_embed ?? "" }}
            // The Wistia loader rewrites this container's contents as soon as
            // its external script runs, which can beat hydration -- React must
            // not reconcile it.
            suppressHydrationWarning
        />
    );
};
